var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rich-text-area"},[_c('label',[_vm._t("default")],2),_c('ckeditor',{attrs:{"editor":_vm.editor,"value":_vm.value,"config":_vm.editorConfig},on:{"input":_vm.updateValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }